const routes = {
  TICKETING: "/ticketing",
  DETAILSTICKET:"/details-ticket/:id",
  DASHBOARD:"/dashboard",
  CALENDEER:"/calendar",
  CALENDARDAY:"/calendar/:year/:month/:day",
  LEADSLIST:"/leads-list",
  DEALMODEL:"/deal-model",
  STAGE:"/stage/:id",
  LEADDATA:"/lead/:id",
  DEALS:"/deals/:id",
  PREVIEW:"/",

};

export default routes;
